import { mediaUrl } from "./media-url";

export const TITLE_MUSIC_URL = mediaUrl("/assets/title-screen/build-your-board.mp3");

let titleMusic: HTMLAudioElement | null = null;

export function titleMenuMusic() {
  if (!titleMusic) {
    titleMusic = new Audio(TITLE_MUSIC_URL);
    titleMusic.loop = true;
    titleMusic.preload = "auto";
    titleMusic.volume = 0.58;
  }
  return titleMusic;
}

export async function playTitleMenuMusic() {
  const audio = titleMenuMusic();
  try { await audio.play(); return true; }
  catch { return false; }
}

/** Every fresh visit to the title screen begins the score from its opening. */
export async function restartTitleMenuMusic() {
  const audio = titleMenuMusic();
  audio.pause();
  audio.currentTime = 0;
  try { await audio.play(); return true; }
  catch { return false; }
}

export function pauseTitleMenuMusic() {
  titleMusic?.pause();
}

export function stopTitleMenuMusic() {
  if (!titleMusic) return;
  titleMusic.pause();
  titleMusic.currentTime = 0;
}
